module.exports = __webpack_public_path__ + "static/img/meizuNode8.2a144ff3.png";